function MediaAudioIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2.5 11C3.05228 11 3.5 11.4305 3.5 11.9616L3.5 18.0384C3.5 18.5695 3.05229 19 2.5 19C1.94772 19 1.5 18.5695 1.5 18.0384L1.5 11.9616C1.5 11.4305 1.94772 11 2.5 11Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.5 7C8.05228 7 8.5 7.45632 8.5 8.01921L8.5 19.9808C8.5 20.5437 8.05229 21 7.5 21C6.94772 21 6.5 20.5437 6.5 19.9808L6.5 8.01921C6.5 7.45632 6.94772 7 7.5 7Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.5 3C13.0523 3 13.5 3.46006 13.5 4.02758L13.5 23.9724C13.5 24.5399 13.0523 25 12.5 25C11.9477 25 11.5 24.5399 11.5 23.9724L11.5 4.02758C11.5 3.46006 11.9477 3 12.5 3Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17.5 9C18.0523 9 18.5 9.44659 18.5 9.99748L18.5 19.0025C18.5 19.5534 18.0523 20 17.5 20C16.9477 20 16.5 19.5534 16.5 19.0025L16.5 9.99748C16.5 9.44659 16.9477 9 17.5 9Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22.5 2C23.0523 2 23.5 2.47294 23.5 3.05634L23.5 25.9437C23.5 26.5271 23.0523 27 22.5 27C21.9477 27 21.5 26.5271 21.5 25.9437L21.5 3.05634C21.5 2.47294 21.9477 2 22.5 2Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M27.5 9C28.0523 9 28.5 9.44659 28.5 9.99748L28.5 19.0025C28.5 19.5534 28.0523 20 27.5 20C26.9477 20 26.5 19.5534 26.5 19.0025L26.5 9.99748C26.5 9.44659 26.9477 9 27.5 9Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M31.5 11C32.0523 11 32.5 11.4226 32.5 11.9438L32.5 17.0562C32.5 17.5774 32.0523 18 31.5 18C30.9477 18 30.5 17.5774 30.5 17.0562L30.5 11.9438C30.5 11.4226 30.9477 11 31.5 11Z'
        />
      </svg>
    </span>
  );
}

export default MediaAudioIcon;
